import { css, styled } from 'styled-components';

const SelectMenuDialog = styled.div.attrs({ role: 'menu' })<{
  menuHeightForFixedPosition?: string;
  menuWidthForFixedPosition?: string;
  noOverflow?: boolean;
}>`
  ${({
    menuHeightForFixedPosition,
    menuWidthForFixedPosition,
    noOverflow = false,
    theme,
  }) => css`
    overflow: ${noOverflow ? 'hidden' : 'auto'};
    border-radius: 10px;
    box-shadow: ${theme.boxShadow.basic20};
    background-color: ${theme.colorsV2.white};
    text-align: left;
    ${menuHeightForFixedPosition
      ? css`
          height: ${menuHeightForFixedPosition};
        `
      : null}
    ${menuWidthForFixedPosition
      ? css`
          width: ${menuWidthForFixedPosition};
        `
      : null}

    & > * {
      &:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
      }

      &:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
      }
    }
  `}
`;

SelectMenuDialog.displayName = 'SelectMenu.Dialog';

export { SelectMenuDialog };
